import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

//import AuthUserContext from './context';

//import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import {AuthUserContext, UserContext, CompanyContext, BranchContext, AccessContext, CashboxContext, SupplierContext, ResellerContext, CustomerContext, ProductCategoryContext, ProductContext} from '../Session/context';
import { withFirebase } from '../Firebase';
//import { withAuthentication } from '.';


const withAuthorization = (condition,routefail=ROUTES.SIGN_IN) => Component => {
    class WithAuthorization extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                authUser:null,
                currentCompany:null,
                currentBranch:null,
                currentUser:null,
                
                ready:false,
                prepared:false,
                
                rejected: null,
                errorPosition:"",

                
                accesses:null,
                appData:{
                  cashboxList:[],
                  supplierList:[],
                  resellerList:[],
                  customerList:[],
                  productCategoryList:[],
                  productList:[],
                  
                },
            };
        }

        componentDidMount() {
            
            this.listener = this.props.firebase.auth.onAuthStateChanged(
                authUser => {
                    if (!condition(authUser)) {
                        if (routefail){//if param=false => skip sll redirect
                            this.props.history.push(routefail)
                        }
                    }else{
                        //console.log("accepted enter page")
                        //accepted enter page
                        //console.log(this.listenerUserObject)
                        this.setState({authUser:authUser})

                        if(!!this.listenerUserObject ) {this.listenerUserObject()}
                        if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                        if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                        if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                        unRegisterSet(this)

                        if(!authUser){
                            
                            this.setState({
                                currentUser:null,
                                currentCompany:null,
                                currentBranch:null,
                                accesses:null,
                                
                                ready:false,
                                prepared:false,
                            })
                            return
                        }
                        
                        
                        this.listenerUserObject= this.props.firebase.fs.doc("users/"+authUser.uid).onSnapshot((userDoc) => {
                        
                            if (userDoc.exists) {
                              
                              this.setState({
                                currentUser:userDoc.data(),
                                //currentCompany:companyDoc.data(),
                                //currentBranch:branchDoc.data(),
                                //accesses:employeeDataDoc.data().accessList,
                              })

                              if(userDoc.data().companyId!=="" && userDoc.data().branchId!==""&&
                                !!this.state.currentCompany&&userDoc.data().companyId===this.state.currentCompany.id &&
                                !!this.state.currentBranch&&userDoc.data().branchId===this.state.currentBranch.id)
                              {
                                //skip unregister
                              }else{
                                if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                unRegisterSet(this)

                              if(userDoc.data().companyId!=="" && userDoc.data().branchId!==""){
                                    //get all data here
                                    
                                    this.listenerCompanyObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyId).onSnapshot((companyDoc) => {
                                        //if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                        //if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                        //unRegisterSet(this)
                                        if (companyDoc.exists) {
                                          this.setState({
                                            //currentUser:userDoc.data(),
                                            currentCompany:companyDoc.data(),
                                            //currentBranch:branchDoc.data(),
                                            //accesses:employeeDataDoc.data().accessList,
                                          })
                                        }else{
                                            this.setState({
                                                currentUser:userDoc.data(),
                                                currentCompany:null,
                                                currentBranch:null,
                                                accesses:null,
                                            })
                                        }
                                        isReady(this)
                                    },(e)=>{
                                        this.setState({rejected:e,errorPosition:"listenerCompanyObject"})
                                    })
                                    
                                    
                                    
                                   
                                    //console.log("companyDoc.id "+companyDoc.id)
                                    this.listenerBranchObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyId+"/branches/"+userDoc.data().branchId).onSnapshot((branchDoc) => {
                                      //if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                      //unRegisterSet(this)
                                      
                                      if (branchDoc.exists) {
                                        this.setState({
                                          //currentUser:userDoc.data(),
                                          //currentCompany:companyDoc.data(),
                                          currentBranch:branchDoc.data(),
                                          //accesses:employeeDataDoc.data().accessList,
                                        })
                                      }else{
                                          this.setState({
                                              currentUser:userDoc.data(),
                                              currentCompany:null,
                                              currentBranch:null,
                                              accesses:null,
                                          })
                                      }
                                      isReady(this)
                                    },(e)=>{
                                        this.setState({rejected:e,errorPosition:"listenerBranchObject"})
                                    })
                                    
                                    
                                    
                                    
                                    //console.log("branchDoc.id "+branchDoc.id)
                                    this.listenerEmployeeDataObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyId+"/branches/"+userDoc.data().branchId+"/employeeData/"+authUser.uid).onSnapshot((employeeDataDoc) => {
                                        //unRegisterSet(this)
                                        if(employeeDataDoc.exists){
                                            //console.log("employeeDataDoc.id "+employeeDataDoc.id)
                                            this.setState({
                                                //currentUser:userDoc.data(),
                                                //currentCompany:companyDoc.data(),
                                                //currentBranch:branchDoc.data(),
                                                accesses:employeeDataDoc.data().accessList,
                                            })
                                        }else{
                                            this.setState({
                                                currentUser:userDoc.data(),
                                                currentCompany:null,
                                                currentBranch:null,
                                                accesses:null,
                                            })
                                        }
                                        isReady(this)
                                    },(e)=>{
                                        this.setState({rejected:e,errorPosition:"listenerEmployeeDataObject"})
                                    })
                                
                                  
                                  
                                  
                                }else{
                                  if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                  if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                  if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                  unRegisterSet(this)
                                  //resign
                                  this.setState({
                                      currentUser:userDoc.data(),
                                      currentCompany:null,
                                      currentBranch:null,
                                      accesses:null,
                                  })
                                }
                              }
                            }else{
                                if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                unRegisterSet(this)
                                //new account here
                                this.setState({
                                    currentUser:null,
                                    currentCompany:null,
                                    currentBranch:null,
                                    accesses:null,
                                })
                            }
                            isReady(this)
                        },(e)=>{
                            this.setState({rejected:e,errorPosition:"listenerUserObject"})
                        })
                        
                            
                            
                        
                        
                        //console.log(this.listenerUserObject)
                    }
                },
            );
            
        }

        componentDidUpdate(){
          
              tryRegisterSet(this,this.props.firebase,this.state.authUser,this.state.currentUser,this.state.currentCompany,this.state.currentBranch,this.state.accesses)
          
        }

        componentWillUnmount() {
            //console.log("componentWillUnmount")
            this.listener();
            if(!!this.listenerUserObject ) {this.listenerUserObject()}
            if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
            if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
            if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
            unRegisterSet(this)
        }
  //condition(authUser,this.props.baseConfig) ? <Component {...this.props} /> : !!authUser? null : routefail?<div>Loading...</div>:<div>Preview Not Available<br /><span>You dont have any access</span></div>
  //condition(baseConfig.authUser) ? <Component {...this.props} baseConfig={baseConfig}/> : baseConfig.authUser==null?<div>Loading...</div>:<div>Preview Not Available<br /><span>You dont have any access</span></div>
        render() {
            return (
                
                <AuthUserContext.Consumer>
                {(authUser) =>{
                    //console.log("Provider")
                    //console.log(this.state.currentUser)
                    //console.log(this.state.currentCompany)
                    //console.log(this.state.currentBranch)
                    //console.log(this.state.accesses)
                    //console.log(this.state.appData.cashbox)
                    //, , , , 
                    return condition(authUser) ?
                        <UserContext.Provider value={this.state.currentUser}>
                            <CompanyContext.Provider value={this.state.currentCompany}>
                                <BranchContext.Provider value={this.state.currentBranch}>
                                    <AccessContext.Provider value={this.state.accesses}>
                                        <CashboxContext.Provider value={this.state.appData.cashboxList}>
                                            <SupplierContext.Provider value={this.state.appData.supplierList}>
                                                <ResellerContext.Provider value={this.state.appData.resellerList}>
                                                    <CustomerContext.Provider value={this.state.appData.customerList}>
                                                        <ProductCategoryContext.Provider value={this.state.appData.productCategoryList}>
                                                            <ProductContext.Provider value={this.state.appData.productList}>
                                                                <Component authUser={authUser} rejected={this.state.rejected} errorPosition={this.state.errorPosition} {...this.props} />
                                                            </ProductContext.Provider>
                                                        </ProductCategoryContext.Provider>
                                                    </CustomerContext.Provider>
                                                </ResellerContext.Provider>
                                            </SupplierContext.Provider>
                                        </CashboxContext.Provider>
                                    </AccessContext.Provider>
                                </BranchContext.Provider>
                            </CompanyContext.Provider>
                        </UserContext.Provider>
                    :
                    !!authUser?
                        null
                        :
                        routefail?
                            <div>Loading...</div>
                            :
                            <div>Preview Not Available<br /><span>You dont have any access</span></div>
                
                    }
                        
                    
                }
                </AuthUserContext.Consumer>
            );
        }
    }


    function isReady(context){
        if(context.state.ready){
            return true
        }else{
            if(!!context.state.currentUser&&!!context.state.currentCompany&&!!context.state.currentBranch&&!!context.state.accesses){
                context.setState({ready:true})
                return true
            }
            return false
        }
    }

    function tryRegisterSet(context,firebase,authUser,user,company,branch,access){
      if(!context.state.ready){
          return
      }
      if(context.state.prepared){
          return
      }
      if(!authUser||!user||!company||!branch){
        return
      }
      //alert("registering")
      unRegisterSet(context)
      switch(company.type){
        case "Finance":
            registerFinanceSet(context,firebase,authUser,user,company,branch,access)
            break;
        case "Production":
            registerProductionSet(context,firebase,authUser,user,company,branch,access)
            break;
        case "Shop":
            registerShopSet(context,firebase,authUser,user,company,branch,access)
            break;
        case "Restaurant":
            registerRestaurantSet(context,firebase,authUser,user,company,branch,access)
            break;
        case "Workshop":
            registerWorkshopSet(context,firebase,authUser,user,company,branch,access)
            break; 
        default:
      }
      context.setState({prepared:true})
    }

    function unRegisterSet(context){
        if(!!context.listenerCashbox ) {context.listenerCashbox()}
        if(!!context.listenerSupplier ) {context.listenerSupplier()}
        if(!!context.listenerReseller ) {context.listenerReseller()}
        if(!!context.listenerCustomer ) {context.listenerCustomer()}
        if(!!context.listenerProductCategory ) {context.listenerProductCategory()}
        if(!!context.listenerProduct ) {context.listenerProduct()}
        context.setState({prepared:false})
    }
    function registerFinanceSet(context,firebase,authUser,user,company,branch,access){
        context.listenerCashbox=registerCashbox(context,firebase,authUser,user,company,branch,access)
        context.listenerSupplier=registerSupplier(context,firebase,authUser,user,company,branch,access)
        context.listenerCustomer=registerCustomer(context,firebase,authUser,user,company,branch,access)
        context.listenerReseller=registerReseller(context,firebase,authUser,user,company,branch,access)
        context.listenerProductCategory=registerProductCategory(context,firebase,authUser,user,company,branch,access)
        context.listenerProduct=registerProduct(context,firebase,authUser,user,company,branch,access)
        
    }
  
    function registerProductionSet(context,firebase,authUser,user,company,branch,access){
        context.listenerCashbox=registerCashbox(context,firebase,authUser,user,company,branch,access)
        context.listenerSupplier=registerSupplier(context,firebase,authUser,user,company,branch,access)
        context.listenerCustomer=registerCustomer(context,firebase,authUser,user,company,branch,access)
        context.listenerReseller=registerReseller(context,firebase,authUser,user,company,branch,access)
        context.listenerProductCategory=registerProductCategory(context,firebase,authUser,user,company,branch,access)
        context.listenerProduct=registerProduct(context,firebase,authUser,user,company,branch,access)
        
    }
  
    function registerShopSet(context,firebase,authUser,user,company,branch,access){
        context.listenerCashbox=registerCashbox(context,firebase,authUser,user,company,branch,access)
        context.listenerSupplier=registerSupplier(context,firebase,authUser,user,company,branch,access)
        context.listenerCustomer=registerCustomer(context,firebase,authUser,user,company,branch,access)
        context.listenerReseller=registerReseller(context,firebase,authUser,user,company,branch,access)
        context.listenerProductCategory=registerProductCategory(context,firebase,authUser,user,company,branch,access)
        context.listenerProduct=registerProduct(context,firebase,authUser,user,company,branch,access)
        
    }
  
    function registerRestaurantSet(context,firebase,authUser,user,company,branch,access){
        context.listenerCashbox=registerCashbox(context,firebase,authUser,user,company,branch,access)
        context.listenerSupplier=registerSupplier(context,firebase,authUser,user,company,branch,access)
        context.listenerCustomer=registerCustomer(context,firebase,authUser,user,company,branch,access)
        context.listenerReseller=registerReseller(context,firebase,authUser,user,company,branch,access)
        context.listenerProductCategory=registerProductCategory(context,firebase,authUser,user,company,branch,access)
        context.listenerProduct=registerProduct(context,firebase,authUser,user,company,branch,access)
        
    }
  
    function registerWorkshopSet(context,firebase,authUser,user,company,branch,access){
        context.listenerCashbox=registerCashbox(context,firebase,authUser,user,company,branch,access)
        context.listenerSupplier=registerSupplier(context,firebase,authUser,user,company,branch,access)
        context.listenerCustomer=registerCustomer(context,firebase,authUser,user,company,branch,access)
        context.listenerReseller=registerReseller(context,firebase,authUser,user,company,branch,access)
        context.listenerProductCategory=registerProductCategory(context,firebase,authUser,user,company,branch,access)
        context.listenerProduct=registerProduct(context,firebase,authUser,user,company,branch,access)
        
    }
  
    
    function registerCashbox(context,firebase,authUser,user,company,branch,access){
        if(!user.companyId||user.companyId===""||!user.branchId||user.branchId===""){
            return null
        }
        return firebase.getFsCol("companies/"+user.companyId+"/branches/"+user.branchId+"/cashbox")
          .onSnapshot( (querySnapshot)=> {
            if(!context.state.appData.cashboxList || context.state.appData.cashboxList.length===0 ){
              var newList=[]
              querySnapshot.forEach((value, index, array)=>{
                newList.push({
                  id: value.id,
                  name: value.data().name,
                  timestamp: value.data().timestamp,
                })
              })
              context.state.appData.cashboxList=newList
              context.setState({
                appData:context.state.appData,
              })
              return
            }
            querySnapshot.docChanges().forEach((change)=> {
              var prevValue=context.state.appData
              var indexData=-1;
              prevValue.cashboxList.forEach((value, index, array)=>{
                if(value.id===change.doc.id){
                  indexData=index
                }
              })
              switch (change.type){
                case "added": case "modified":
                    //console.log(indexData +" "+ change.type + " cashbox: ", change.doc.data().name);
                    if(indexData>=0){
                      prevValue.cashboxList[indexData]={
                        id: change.doc.id,
                        name: change.doc.data().name,
                        timestamp: change.doc.data().timestamp,
                      }
                    }else{
                      prevValue.cashboxList.push({
                        id: change.doc.id,
                        name: change.doc.data().name,
                        timestamp: change.doc.data().timestamp,
                      })
                    }
                    break
      
                case "removed":
                    //console.log(indexData + " removed cashbox: ", change.doc.data().name);
                    if(indexData>=0){
                      prevValue.cashboxList.splice(indexData, 1)
                    }
                    break
                default:
                    //console.log("default cashbox: ", change.doc.data());
              }
              context.setState({
                appData:prevValue,
              })
            });
          },(e)=>{
              context.setState({rejected:e,errorPosition:"registerCashbox"})
          })
        
      
    }

    function registerSupplier(context,firebase,authUser,user,company,branch,access){
        if(!user.companyId||user.companyId===""||!user.branchId||user.branchId===""){
            return null
        }
        return firebase.getFsCol("companies/"+user.companyId+"/suppliers")
            .onSnapshot( (querySnapshot)=> {
              if(!context.state.appData.supplierList || context.state.appData.supplierList.length===0 ){
                var newList=[]
                querySnapshot.forEach((value, index, array)=>{
                  newList.push({
                    id: value.id,
                    code: value.data().code,
                    name: value.data().name,
                    rank: value.data().rank,
                    email: value.data().email,
                    email2: value.data().email2,
                    phone: value.data().phone,
                    phone2: value.data().phone2,
                    birthday: value.data().birthday,
                    address: value.data().address,
                    town: value.data().town,
                    address2: value.data().address2,
                    town2: value.data().town2,
                    npwp: value.data().npwp,
                    timestamp: value.data().timestamp,
                  })
                })
                context.state.appData.supplierList=newList
                context.setState({
                  appData:context.state.appData,
                })
                return
              }
              querySnapshot.docChanges().forEach((change)=> {
                var prevValue=context.state.appData
                var indexData=-1;
                prevValue.supplierList.forEach((value, index, array)=>{
                  if(value.id===change.doc.id){
                    indexData=index
                  }
                })
                switch (change.type){
                  case "added": case "modified":
                      //console.log(indexData +" "+ change.type + " cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.supplierList[indexData]={
                          id: change.doc.id,
                          code: change.doc.data().code,
                          name: change.doc.data().name,
                          rank: change.doc.data().rank,
                          email: change.doc.data().email,
                          email2: change.doc.data().email2,
                          phone: change.doc.data().phone,
                          phone2: change.doc.data().phone2,
                          birthday: change.doc.data().birthday,
                          address: change.doc.data().address,
                          town: change.doc.data().town,
                          address2: change.doc.data().address2,
                          town2: change.doc.data().town2,
                          npwp: change.doc.data().npwp,
                          timestamp: change.doc.data().timestamp,
                        }
                      }else{
                        prevValue.supplierList.push({
                            id: change.doc.id,
                            code: change.doc.data().code,
                            name: change.doc.data().name,
                            rank: change.doc.data().rank,
                            email: change.doc.data().email,
                            email2: change.doc.data().email2,
                            phone: change.doc.data().phone,
                            phone2: change.doc.data().phone2,
                            birthday: change.doc.data().birthday,
                            address: change.doc.data().address,
                            town: change.doc.data().town,
                            address2: change.doc.data().address2,
                            town2: change.doc.data().town2,
                            npwp: change.doc.data().npwp,
                            timestamp: change.doc.data().timestamp,
                        })
                      }
                      break
        
                  case "removed":
                      //console.log(indexData + " removed cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.supplierList.splice(indexData, 1)
                      }
                      break
                  default:
                      //console.log("default cashbox: ", change.doc.data());
                }
                context.setState({
                    appData:prevValue,
                })
                
              });
            },(e)=>{
                context.setState({rejected:e,errorPosition:"registerSupplier"})
            })
        
        
    }

    function registerCustomer(context,firebase,authUser,user,company,branch,access){
        if(!user.companyId||user.companyId===""||!user.branchId||user.branchId===""){
            return null
        }
        return firebase.getFsCol("companies/"+user.companyId+"/customers")
            .onSnapshot( (querySnapshot)=> {
              if(!context.state.appData.customerList || context.state.appData.customerList.length===0 ){
                var newList=[]
                querySnapshot.forEach((value, index, array)=>{
                  newList.push({
                    id: value.id,
                    code: value.data().code,
                    name: value.data().name,
                    rank: value.data().rank,
                    email: value.data().email,
                    email2: value.data().email2,
                    phone: value.data().phone,
                    phone2: value.data().phone2,
                    birthday: value.data().birthday,
                    address: value.data().address,
                    town: value.data().town,
                    address2: value.data().address2,
                    town2: value.data().town2,
                    npwp: value.data().npwp,
                    timestamp: value.data().timestamp,
                  })
                })
                context.state.appData.customerList=newList
                context.setState({
                  appData:context.state.appData,
                })
                return
              }
              querySnapshot.docChanges().forEach((change)=> {
                var prevValue=context.state.appData
                var indexData=-1;
                prevValue.customerList.forEach((value, index, array)=>{
                  if(value.id===change.doc.id){
                    indexData=index
                  }
                })
                switch (change.type){
                  case "added": case "modified":
                      //console.log(indexData +" "+ change.type + " cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.customerList[indexData]={
                          id: change.doc.id,
                          code: change.doc.data().code,
                          name: change.doc.data().name,
                          rank: change.doc.data().rank,
                          email: change.doc.data().email,
                          email2: change.doc.data().email2,
                          phone: change.doc.data().phone,
                          phone2: change.doc.data().phone2,
                          birthday: change.doc.data().birthday,
                          address: change.doc.data().address,
                          town: change.doc.data().town,
                          address2: change.doc.data().address2,
                          town2: change.doc.data().town2,
                          npwp: change.doc.data().npwp,
                          timestamp: change.doc.data().timestamp,
                        }
                      }else{
                        prevValue.customerList.push({
                            id: change.doc.id,
                            code: change.doc.data().code,
                            name: change.doc.data().name,
                            rank: change.doc.data().rank,
                            email: change.doc.data().email,
                            email2: change.doc.data().email2,
                            phone: change.doc.data().phone,
                            phone2: change.doc.data().phone2,
                            birthday: change.doc.data().birthday,
                            address: change.doc.data().address,
                            town: change.doc.data().town,
                            address2: change.doc.data().address2,
                            town2: change.doc.data().town2,
                            npwp: change.doc.data().npwp,
                            timestamp: change.doc.data().timestamp,
                        })
                      }
                      break
        
                  case "removed":
                      //console.log(indexData + " removed cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.customerList.splice(indexData, 1)
                      }
                      break
                  default:
                      //console.log("default cashbox: ", change.doc.data());
                }
                context.setState({
                    appData:prevValue,
                })
                
              });
            },(e)=>{
                context.setState({rejected:e,errorPosition:"registerCustomer"})
            })
        
        
    }

    function registerReseller(context,firebase,authUser,user,company,branch,access){
        if(!user.companyId||user.companyId===""||!user.branchId||user.branchId===""){
            return null
        }
        return firebase.getFsCol("companies/"+user.companyId+"/resellers")
            .onSnapshot( (querySnapshot)=> {
              if(!context.state.appData.resellerList || context.state.appData.resellerList.length===0 ){
                var newList=[]
                querySnapshot.forEach((value, index, array)=>{
                  newList.push({
                    id: value.id,
                    code: value.data().code,
                    name: value.data().name,
                    rank: value.data().rank,
                    email: value.data().email,
                    email2: value.data().email2,
                    phone: value.data().phone,
                    phone2: value.data().phone2,
                    birthday: value.data().birthday,
                    address: value.data().address,
                    town: value.data().town,
                    address2: value.data().address2,
                    town2: value.data().town2,
                    npwp: value.data().npwp,
                    timestamp: value.data().timestamp,
                  })
                })
                context.state.appData.resellerList=newList
                context.setState({
                  appData:context.state.appData,
                })
                return
              }
              querySnapshot.docChanges().forEach((change)=> {
                var prevValue=context.state.appData
                var indexData=-1;
                prevValue.resellerList.forEach((value, index, array)=>{
                  if(value.id===change.doc.id){
                    indexData=index
                  }
                })
                switch (change.type){
                  case "added": case "modified":
                      //console.log(indexData +" "+ change.type + " cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.resellerList[indexData]={
                          id: change.doc.id,
                          code: change.doc.data().code,
                          name: change.doc.data().name,
                          rank: change.doc.data().rank,
                          email: change.doc.data().email,
                          email2: change.doc.data().email2,
                          phone: change.doc.data().phone,
                          phone2: change.doc.data().phone2,
                          birthday: change.doc.data().birthday,
                          address: change.doc.data().address,
                          town: change.doc.data().town,
                          address2: change.doc.data().address2,
                          town2: change.doc.data().town2,
                          npwp: change.doc.data().npwp,
                          timestamp: change.doc.data().timestamp,
                        }
                      }else{
                        prevValue.resellerList.push({
                            id: change.doc.id,
                            code: change.doc.data().code,
                            name: change.doc.data().name,
                            rank: change.doc.data().rank,
                            email: change.doc.data().email,
                            email2: change.doc.data().email2,
                            phone: change.doc.data().phone,
                            phone2: change.doc.data().phone2,
                            birthday: change.doc.data().birthday,
                            address: change.doc.data().address,
                            town: change.doc.data().town,
                            address2: change.doc.data().address2,
                            town2: change.doc.data().town2,
                            npwp: change.doc.data().npwp,
                            timestamp: change.doc.data().timestamp,
                        })
                      }
                      break
        
                  case "removed":
                      //console.log(indexData + " removed cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.resellerList.splice(indexData, 1)
                      }
                      break
                  default:
                      //console.log("default cashbox: ", change.doc.data());
                }
                context.setState({
                    appData:prevValue,
                })
                
              });
            },(e)=>{
                context.setState({rejected:e,errorPosition:"registerReseller"})
            })
        
        
    }

    function registerProductCategory(context,firebase,authUser,user,company,branch,access){
        if(!user.companyId||user.companyId===""||!user.branchId||user.branchId===""){
            return null
        }
        return firebase.getFsCol("companies/"+user.companyId+"/productCategories")
            .onSnapshot( (querySnapshot)=> {
              if(!context.state.appData.productCategoryList || context.state.appData.productCategoryList.length===0 ){
                var newList=[]
                querySnapshot.forEach((value, index, array)=>{
                  newList.push({
                    id: value.id,
                    name: value.data().name,
                    prefix: value.data().prefix,
                    parentId: value.data().parentId,
                    parentName: value.data().parentName,
                    type: value.data().type,
                    timestamp: value.data().timestamp,
                })
                })
                context.state.appData.productCategoryList=newList
                context.setState({
                  appData:context.state.appData,
                })
                return
              }
              querySnapshot.docChanges().forEach((change)=> {
                var prevValue=context.state.appData
                var indexData=-1;
                prevValue.productCategoryList.forEach((value, index, array)=>{
                  if(value.id===change.doc.id){
                    indexData=index
                  }
                })
                switch (change.type){
                  case "added": case "modified":
                      //console.log(indexData +" "+ change.type + " cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.productCategoryList[indexData]={
                            id: change.doc.id,
                            name: change.doc.data().name,
                            prefix: change.doc.data().prefix,
                            parentId: change.doc.data().parentId,
                            parentName: change.doc.data().parentName,
                            type: change.doc.data().type,
                            timestamp: change.doc.data().timestamp,
                        }
                      }else{
                        prevValue.productCategoryList.push({
                            id: change.doc.id,
                            name: change.doc.data().name,
                            prefix: change.doc.data().prefix,
                            parentId: change.doc.data().parentId,
                            parentName: change.doc.data().parentName,
                            type: change.doc.data().type,
                            timestamp: change.doc.data().timestamp,
                        })
                      }
                      break
        
                  case "removed":
                      //console.log(indexData + " removed cashbox: ", change.doc.data().name);
                      if(indexData>=0){
                        prevValue.productCategoryList.splice(indexData, 1)
                      }
                      break
                  default:
                      //console.log("default cashbox: ", change.doc.data());
                }
                context.setState({
                    appData:prevValue,
                })
                
              });
            },(e)=>{
                context.setState({rejected:e,errorPosition:"registerProductCategory"})
            })
        
        
    }

    function registerProduct(context,firebase,authUser,user,company,branch,access){
        if(!user.companyId||user.companyId===""||!user.branchId||user.branchId===""){
            return null
        }
        return firebase.getFsCol("companies/"+user.companyId+"/products")
        .onSnapshot( (querySnapshot)=> {
          if(!context.state.appData.productList || context.state.appData.productList.length===0 ){
            var newList=[]
            querySnapshot.forEach((value, index, array)=>{
              newList.push({
                id: value.id,
                //type: change.doc.data().type,
                categoryId: value.data().categoryId,
                categoryType: value.data().categoryType,
                categoryName: value.data().categoryName,
                code: value.data().code,
                name: value.data().name,
                info: value.data().info,
                detail: value.data().detail,
                image: value.data().image,
                image1: value.data().image1,
                image2: value.data().image2,
                image3: value.data().image3,
                image4: value.data().image4,
                image5: value.data().image5,
                unit: value.data().unit,
                weight: value.data().weight,
                basePrice: value.data().basePrice,
                salePrice: value.data().salePrice,
                stockIn: value.data().stockIn,
                stockOut: value.data().stockOut,
                stockAmount: value.data().stockAmount,
                value: value.data().value,
                location: value.data().location,
                luxurious: value.data().luxurious,
                bkp: value.data().bkp,
                expiration: value.data().expiration,
                timestamp: value.data().timestamp,
              })
            })
            context.state.appData.productList=newList
            context.setState({
              appData:context.state.appData,
            })
            return
          }
          querySnapshot.docChanges().forEach((change)=> {
            var prevValue=context.state.appData
            var indexData=-1;
            prevValue.productList.forEach((value, index, array)=>{
              if(value.id===change.doc.id){
                indexData=index
              }
            })
            switch (change.type){
              case "added": case "modified":
                  //console.log(indexData +" "+ change.type + " cashbox: ", change.doc.data().name);
                  if(indexData>=0){
                    prevValue.productList[indexData]={
                      id: change.doc.id,
                      //type: change.doc.data().type,
                      categoryId: change.doc.data().categoryId,
                      categoryType: change.doc.data().categoryType,
                      categoryName: change.doc.data().categoryName,
                      code: change.doc.data().code,
                      name: change.doc.data().name,
                      info: change.doc.data().info,
                      detail: change.doc.data().detail,
                      image: change.doc.data().image,
                      image1: change.doc.data().image1,
                      image2: change.doc.data().image2,
                      image3: change.doc.data().image3,
                      image4: change.doc.data().image4,
                      image5: change.doc.data().image5,
                      unit: change.doc.data().unit,
                      weight: change.doc.data().weight,
                      basePrice: change.doc.data().basePrice,
                      salePrice: change.doc.data().salePrice,
                      stockIn: change.doc.data().stockIn,
                      stockOut: change.doc.data().stockOut,
                      stockAmount: change.doc.data().stockAmount,
                      value: change.doc.data().value,
                      location: change.doc.data().location,
                      luxurious: change.doc.data().luxurious,
                      bkp: change.doc.data().bkp,
                      expiration: change.doc.data().expiration,
                      timestamp: change.doc.data().timestamp,
                    }
                  }else{
                    prevValue.productList.push({
                      id: change.doc.id,
                      //type: change.doc.data().type,
                      categoryId: change.doc.data().categoryId,
                      categoryType: change.doc.data().categoryType,
                      categoryName: change.doc.data().categoryName,
                      code: change.doc.data().code,
                      name: change.doc.data().name,
                      info: change.doc.data().info,
                      detail: change.doc.data().detail,
                      image: change.doc.data().image,
                      image1: change.doc.data().image1,
                      image2: change.doc.data().image2,
                      image3: change.doc.data().image3,
                      image4: change.doc.data().image4,
                      image5: change.doc.data().image5,
                      unit: change.doc.data().unit,
                      weight: change.doc.data().weight,
                      basePrice: change.doc.data().basePrice,
                      salePrice: change.doc.data().salePrice,
                      stockIn: change.doc.data().stockIn,
                      stockOut: change.doc.data().stockOut,
                      stockAmount: change.doc.data().stockAmount,
                      value: change.doc.data().value,
                      location: change.doc.data().location,
                      luxurious: change.doc.data().luxurious,
                      bkp: change.doc.data().bkp,
                      expiration: change.doc.data().expiration,
                      timestamp: change.doc.data().timestamp,
                    })
                  }
                  break
    
              case "removed":
                  //console.log(indexData + " removed cashbox: ", change.doc.data().name);
                  if(indexData>=0){
                    prevValue.productList.splice(indexData, 1)
                  }
                  break
              default:
                  //console.log("default cashbox: ", change.doc.data());
            }
            context.setState({
                appData:prevValue,
            })
            
          });
        },(e)=>{
            context.setState({rejected:e,errorPosition:"registerProduct"})
        })
        
        
    }






    return compose(
        withRouter,
        withFirebase,
    )(WithAuthorization);
};

export default withAuthorization;